import { render, staticRenderFns } from "./feature-details-popup.component.vue?vue&type=template&id=df671d8e&"
import script from "./feature-details-popup.component.vue?vue&type=script&lang=js&"
export * from "./feature-details-popup.component.vue?vue&type=script&lang=js&"
import style0 from "./feature-details-popup.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports